<ngx-app-bar
  class="w-100"
  [title]="'تراکنش‌ها'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
/>

@if (isLoading()) {
  <app-spinner></app-spinner>
} @else {
  <div class="d-flex flex-wrap">
    @if (onlineTRXLoading()) {
      <app-loading-trx class="w-100 d-flex justify-content-center" />
    }
    <app-transaction-list
      class="w-100"
      [transactions]="transactions()"
      [lastPage]="lastPage()"
      [isLoadingMore]="isLoadingMore()"
      (getNextPage)="getNextPage($event)"
      [containerStyle]="onlineTRXLoading() ? { height: 'calc(100dvh - 14rem)' } : { height: 'calc(100dvh - 7rem)' }"
    ></app-transaction-list>
  </div>
}
